import React from "react";
import { createMotionTag } from "./lazy-motion-utils";

// Export a Proxy so any tag access (e.g., motion.tr) returns a motion-like component.
const cache: Record<string, React.ElementType> = {};
const motion = new Proxy(cache as Record<string, React.ElementType>, {
  get(target, prop: PropertyKey) {
    const key = String(prop);
    if (!(key in target)) target[key] = createMotionTag(key);
    return target[key];
  }
});

export default motion;
